<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-6"><a href="#/Ruddy_Gore2#Contents-A">Epigraph</a></p>
<p class="fp">‘They do it with mirrors, my boy.’</p>
<p class="body">		Colonel Pewter in Ironicus, Arthur Hormer</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ruddy_Gore-5.vue?051fb1db